import {$host} from "./index";

export const fetchExhibits = async (filterObject, page, plantType) => {
    const {data} = await $host.get('exhibits/',
        {params: {...filterObject, page, plantType}})
    return data
}

export const createExhibitInfo = async (exhibitInfoObject) => {
    const {data} = await $host.post('exhibits/', { ...exhibitInfoObject })
    return data
}

export const addExhibitPhotos = async (file, id) => {
    const formData = new FormData
    formData.append('file', file)
    const {data} = await $host.post('exhibits/' + `${id}`, formData)
    return data
}

export const addExhibitLabelPhotos = async (file, id) => {
    const formData = new FormData
    formData.append('file', file)
    const {data} = await $host.post('exhibits/' + `${id}` + "/original-label", formData)
    return data;
}

export const fetchOneExhibit = async (id) => {
    const {data} = await $host.get('exhibits/' + `${id}`)
    return data
}

export const fetchStatisticsExhibit = async (id) => {
    const {data} = await $host.get('exhibits/statistics')
    return data
}

export const deleteExhibit = async (id) => {
    const {data} = await $host.delete('exhibits/' + `${id}`)
    return data
}

export const deleteExhibitPhoto = async (id, photoId) => {
    const {data} = await $host.delete('exhibits/' + `${id}/` + 'photos/' + `${photoId}`)
    return data
}

export const deleteExhibitLabelPhotos = async (id, photoId) => {
    const {data} = await $host.delete('exhibits/' + `${id}/` + 'original-label-photos/' + `${photoId}`)
    return data
}

export const updateExhibit = async (id, updatedExhibit) => {
    const {data} = await $host.patch('exhibits/' + `${id}`, { ...updatedExhibit })
    return data
}

export const fetchAllExhibits = async (species, page) => {
    const {data} = await $host.get('exhibits/species/' + `${species}`, {params: {page}})
    return data
}